module.exports = __webpack_public_path__ + "img/terms-n-conditions.23903271.png";